(function() {
    'use strict';

    var ContoAddebitoCtrl = function(
        $stateParams,
        messaggiFctr,
        contoAddebitoService,
        gestioneUtenteService
    ) {
        this.loading = 0;
        this.contoAddebitoService = contoAddebitoService;

        this.listaContiAddebito = [];
        this.tipoContoAddebito = '';
        this.gestioneUtenteService = gestioneUtenteService;

        this.init = () => {
            if (!contoAddebitoService.listiniMito || !contoAddebitoService.listiniMito.length) {
                this.loading = (this.loading > 0) ? this.loading + 1 : 1;
                contoAddebitoService.getListinoMto().then(
                    (res) => {
                        contoAddebitoService.listiniMito = [];
                        res.data.forEach((listino) => {
                            contoAddebitoService.listiniMito.push({
                                cod: listino.codiceProdottoCPT,
                                dsc: listino.descrizione
                            });
                        });
                        this.loading--;
                    },
                    (error) => {
                        this.loading--;
                        messaggiFctr.processaResponse(error);
                    }
                );
            }
            this.listaContiAddebito = [];
            this.tipoContoAddebito = 'S';            
            this.loading = (this.loading > 0) ? this.loading + 1 : 1;
            this.loadingContiAddebito = true;

            let servizioRecuperoListaConti = contoAddebitoService.getContiAddebito;
            let parametroServizio = $stateParams.codiceUtente;
            let elaborazioneListaConti = function (result) {
                if (result.data.result.length > 0) {
                    this.listaContiAddebito.push({ cod: '0', dsc: 'Nessun addebito' });
                    this.listaContiAddebito.push({ cod: '-', dsc: '------' });
                    result.data.result.forEach((rapporto) => {
                        this.listaContiAddebito.push({
                            cod: rapporto.numeroRapporto.trim(),
                            dsc: rapporto.numeroRapporto.trim() + ' - ' + rapporto.intestatario
                        });
                    });
                }
            }

            if (gestioneUtenteService.praticaPic.tipo == 'INSERIMENTO') {
                servizioRecuperoListaConti = contoAddebitoService.getContiDisponibili;
                parametroServizio = $stateParams.ndg;
                elaborazioneListaConti = function (result) {
                    if (result.data.contiCorrentiValutaEuro.length > 0) {
                        this.listaContiAddebito = [];
                        result.data.contiCorrentiValutaEuro.forEach((rapporto) => {
                            this.listaContiAddebito.push({
                                numeroRapporto: rapporto.NumeroRapporto,
                                intestazioneCliente: rapporto.Intestatario,
                                prodotto: rapporto.Descrizione,
                                stato: rapporto.Stato
                            });
                        });
                    }
                }
            }

            servizioRecuperoListaConti.call(null, parametroServizio).then(
                (res) => {
                    this.loadingContiAddebito = false;
                    this.labelRecuperoListaConti = false;
                    elaborazioneListaConti.call(this, res);
                    if (!!gestioneUtenteService.datiMito.datiAddebito) {
                    this.tipoContoAddebito = this.listaContiAddebito.some((rap) =>
                        rap.cod === gestioneUtenteService.datiMito.datiAddebito.contoAddebito) ? 'S' : 'M';
                        this.updateTipoConto();
                        if (gestioneUtenteService.datiMito.datiAddebito.addebitoCommissioni === 0) {
                            this.resetContoAddebito();
                        };
                    }
                    this.loading--;
                },
                (error) => {
                    this.loading--;
                    this.loadingContiAddebito = false;
                    this.labelRecuperoListaConti = 'Si e\' verificato un errore nel recupero dei dati.';
                    messaggiFctr.processaResponse(error);
                }
            );

            if (!contoAddebitoService.categorieUtente || !contoAddebitoService.categorieUtente.length) {
                contoAddebitoService.getCategorieUtente($stateParams.codiceUtente || '-').then(
                    (res) => {
                        if (messaggiFctr.processaResponse(res)) {
                            return;
                        }
                        contoAddebitoService.categorieUtente = res.data.result;
                    },
                    (error) => {
                        messaggiFctr.processaResponse(error);
                    }
                );
            }
        };

        this.updateTipoConto = () => {
            gestioneUtenteService.datiMito.contoAddebitoManuale =
                this.tipoContoAddebito === 'M';
        };

        this.resetContoAddebito = () => {
            this.tipoContoAddebito = 'S';
            this.updateTipoConto();
            gestioneUtenteService.datiMito.datiAddebito.contoAddebito = '0'
        };

        this.codiceListinoMitoNonTrovato = () => {
            if (!!$stateParams.codiceProdotto && (gestioneUtenteService.praticaPic.tipo == 'INSERIMENTO') && !this.gestioneUtenteService.datiMito.datiAddebito) {
                this.gestioneUtenteService.datiMito.datiAddebito = {
                    "codiceListinoMito": $stateParams.codiceProdotto
                };
            }
            let listinoUtente = this.gestioneUtenteService.datiMito.datiAddebito.codiceListinoMito || '';
            return this.loading === 0 && !!this.gestioneUtenteService.datiMito.datiAddebito && !contoAddebitoService.listiniMito.some(listino => listino.cod === listinoUtente.trim());
        }

        let getForm = (root) => {
            if (root.mitoForm) return root.mitoForm;
            if (root.$id == root.$parent.$id) return { '$valid': true };
            return getForm(root.$parent);
        };

        this.checkCampoValido = () => {
            return this.gestioneUtenteService.checkCampoValido('utente');
        };

        this.init();
    };

    ContoAddebitoCtrl.$inject = [
        '$stateParams',
        'MitomMessaggiFctr',
        'MitomContoAddebitoService',
        'MitomGestioneUtenteService'
    ];

    let TemplateUrl = function(CONSTANTS) {
        return (
            CONSTANTS.BASE_ROOT +
            CONSTANTS.COMPONENTS_PATH +
            'mitoman-gestione-utente/mitoman-dati-utente-mito/mitoman-conto-addebito/contoAddebito.component.html'
        );
    };
    TemplateUrl.$inject = ['Mitom_CONSTANTS'];

    const ContoAddebitoComponent = {
        controller: ContoAddebitoCtrl,
        controllerAs: 'contoAddebitoCtrl',
        templateUrl: TemplateUrl
    };

    angular
        .module('cbl.mitomanager.wa')
        .component('mitomcontoAddebito', ContoAddebitoComponent);
})();